import { CalendarResponse, District, League, Nullish, School, Sport, State } from 'types'

export const FEATURE_NAME = 'filters'

export interface IState {
  state: State[]
  district: District[]
  sport: Sport[]
  isSportChangeable: boolean
  school: School[]
  isLeague: boolean
  league: League[]
  date: Nullish<string>
  calendar: CalendarResponse
  isCalendarLoaded: boolean
}

export const CALENDAR_PAGE_SIZE = 7
